// extracted by mini-css-extract-plugin
export default {"container":"ImageItem_container__GNrxY"};